<template>
	<div class="media-player mb-3">
		<!-- Media container -->
		<div class="media-player-container flex flex-col items-center justify-center" v-if="media">
			<!-- Video -->
			<video
			autoplay disablePictureInPicture
			controls="true"
			controlsList="nodownload"
			v-if="media.path && (media.path.indexOf('mp4') || media.path.indexOf('m4v') > -1)"
			ref="video"
			@play="updatePlayState"
			@playing="updatePlayState"
			@pause="updatePlayState"
			@ended="videoEnded">
				<source :src="media.url" type="video/mp4">
			</video>

			<!-- Image -->
			<img v-else-if="media.type.slug == 'file_image'" :src="media.url">
		</div>
	</div>
</template>

<script>
	export default {
		name: 'MediaPlayer',
		props: {
			media: {
				type: Object,
				required: false,
				default: null
			}
		},
		data() {
			return {
				isPlaying: false,
			}
		},
		watch: {
			media: {
				handler(media, oldMedia) {
					// Reset states
					this.isPlaying = false

					// Force sources update/reload when going to a new media
					if (media && oldMedia && media.id != oldMedia.id) {
						if (this.$refs.video)
							this.$refs.video.load()
					}
				},
				immediate: true,
			},
			isPlaying: {
				handler(isPlaying) {
					this.$emit('playing', isPlaying)
				},
				immediate: true,
			},
		},
		beforeDestroy() {
			// Stop video (some browser keep playing even if the HTML node is removed)
			this.stop()
		},
		methods: {
			updatePlayState() {
				if (!this.$refs.video)
					return

				this.isPlaying = !this.$refs.video.paused;
			},
			playPause() {
				if (this.$refs.video) {
					if (this.$refs.video.paused) {
						this.$refs.video.play()
					} else {
						this.$refs.video.pause()
					}
				}
				this.updatePlayState()
			},
			stop() {
				// Pause video and go to the end
				if (this.$refs.video) {
					this.$refs.video.pause()
					this.$refs.video.currentTime = (this.$refs.video.duration - 1)
					this.updatePlayState()
				}
			},
			videoEnded() {
				this.$emit('ended')
			},
			nextClick() {
				this.$emit('next')
			}
		}
	}
</script>

<style lang="scss">
.media-player {
	width: 100%;
	max-width: 100%;
	height: 100%;
	max-height: 100%;

	&-container {
		width: 100%;
		max-width: 100%;
		height: 100%;
		max-height: 100%;
	}

	video, img {
		width: auto;
		max-width: 100%;
		height: auto;
		max-height: 100%;
	}

	video::-internal-media-controls-download-button {
		display:none !important;
	}

	video::-webkit-media-controls-enclosure {
		overflow:hidden !important;
	}

	video::-webkit-media-controls-panel {
		width: calc(100% + 30px) !important; /* Adjust as needed */
	}
}
</style>
